import { render, staticRenderFns } from "./Speech.vue?vue&type=template&id=a2ed0dc4&"
import script from "./Speech.vue?vue&type=script&lang=js&"
export * from "./Speech.vue?vue&type=script&lang=js&"
import style0 from "./Speech.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2ed0dc4')) {
      api.createRecord('a2ed0dc4', component.options)
    } else {
      api.reload('a2ed0dc4', component.options)
    }
    module.hot.accept("./Speech.vue?vue&type=template&id=a2ed0dc4&", function () {
      api.rerender('a2ed0dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Speech.vue"
export default component.exports